import React, { forwardRef, useState, useEffect, useRef } from "react";

const Slider = forwardRef(({ 
  className, 
  min = 0, 
  max = 100, 
  step = 1,
  value = 0,
  defaultValue,
  onChange,
  ...props 
}, ref) => {
  const [currentValue, setCurrentValue] = useState(defaultValue !== undefined ? defaultValue : value);
  const trackRef = useRef(null);
  
  useEffect(() => {
    if (value !== undefined && value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value]);
  
  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    setCurrentValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  
  const percentage = ((currentValue - min) / (max - min)) * 100;
  
  return (
    <div className={`relative flex w-full touch-none select-none items-center ${className}`} ref={ref} {...props}>
      <div className="relative h-2 w-full grow overflow-hidden rounded-full bg-gray-200" ref={trackRef}>
        <div 
          className="absolute h-full bg-blue-600" 
          style={{ width: `${percentage}%` }}
        />
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={currentValue}
        onChange={handleChange}
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
      />
      <div 
        className="absolute h-5 w-5 rounded-full border-2 border-blue-600 bg-white shadow transform -translate-y-1/2 top-1/2"
        style={{ left: `calc(${percentage}% - 10px)` }}
      />
    </div>
  );
});

Slider.displayName = "Slider";

export { Slider };
